var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12656 15.2367C0.901563 15.2367 0.676562 15.1617 0.526562 14.9742C0.189063 14.6367 0.189063 14.1117 0.526562 13.7742L11.8891 2.41172H2.81406C2.36406 2.41172 1.98906 2.03672 1.98906 1.58672C1.98906 1.13672 2.36406 0.761719 2.81406 0.761719H13.8766C14.3266 0.761719 14.7016 1.13672 14.7016 1.58672V12.7242C14.7016 13.1742 14.3266 13.5492 13.8766 13.5492C13.4266 13.5492 13.0516 13.1742 13.0516 12.7242V3.68672L1.72656 15.0117C1.57656 15.1617 1.35156 15.2367 1.12656 15.2367Z",
    fill: "#CB9B50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg40);
export default __webpack_public_path__ + "static/media/svg40.47900dcf6b344ca0a8880aa9c13282f6.svg";
export { ForwardRef as ReactComponent };